<template>
  <div id="app">
    <MyHeader v-if="!isHideHeader"></MyHeader>
    <!-- 交易记录、喜欢使用明细、我喜欢的人等列表不做缓存 -->
    <keep-alive :exclude="['Transcation', 'LikeDetail', 'Ask', 'Follow', 'Like', 'LikeMe']">
      <router-view
        v-if="
          userData.singleStatus !== 6 && userData.singleStatus !== 7 ||
          $route.name === 'Home' ||
          $route.name === 'Messages' ||
          $route.name === 'Account' ||
          $route.name === 'Setting'
        "
      />
      <NotSingle v-else />
    </keep-alive>
    <pageLoading v-if="$root.isLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import wxApi from '@/utils/wxAuth'

import MyHeader from '@/components/common/myHeader.vue'
import PageLoading from '@/components/common/pageLoading.vue'
import NotSingle from '@/components/common/notSingle.vue'
export default {
  name: 'app',
  components: {
    MyHeader,
    PageLoading,
    NotSingle
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    isHideHeader () {
      return this.$route.meta.isHideHeader || false
    }
  },
  mounted () {
    //友盟统计
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1278666268&web_id=1278666268'
    script.language = 'JavaScript'
    document.body.appendChild(script)
    function getScrollTop () {
      var scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    }

    var oldScrollTop = 0

    // TODO: 在ios12版本以上处理
    document.body.addEventListener('focusin', () => { // 软键盘弹起事件
      oldScrollTop = getScrollTop() || 0
    })
    document.body.addEventListener('focusout', () => { // 软键盘关闭事件
      var ua = window.navigator.userAgent
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0) { // 键盘收起页面空白问题
        document.body.scrollTop = oldScrollTop
        document.documentElement.scrollTop = oldScrollTop
      }
    })

    this.$http('/api/login/wx/jssdk/config/get', {
      pageUrl: location.href
    }, 'get').then(res => {
      if (res.code === '0000') {
        wxApi.config(res.data).configShare()
      }
    }, err => {
      //this.$toast(err)
    })
  },
  watch: {
    //友盟统计
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
@import "@/assets/scss/common.scss";
#app {
  font-family: 'PingFangSC-Regular', 'PingFang SC', 'sans-serif', 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  margin: 0 auto;
  width: $clientWidth;
  min-height: 100%;
  position: relative;
}
</style>
